import { nullable, number, object, string } from "superstruct";

export const BoostCampaignSchema = nullable(
    object({
        pointsMultiplier: number(),
        startsAt: string(),
        endsAt: string(),
    })
);

export const BoostCampaignResponseSchema = object({
    boostCampaign: BoostCampaignSchema,
});
